import {Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, TextField} from "@mui/material";
import PaperDraggable from "../../../../../components/PaperDraggable";
import { FormProvider, useForm } from "react-hook-form";
import {useMutation, useQueryClient} from "react-query";
import axiosClient from "../../../../../lib/axios";
import { enqueueSnackbar } from "notistack";
import {useMemo, useState} from "react";
import {ICultura, TOpenModalCulturas} from "../ListarCulturas/Listagem";

export default function DialogIncluirEditarCultura({
                                                 open,
                                                 handleClose, defaultValue
                                             }: DialogIncluirCulturaProps) {
    const isEdit = useMemo(() => Boolean(defaultValue), [defaultValue])

    const [isSubmitting, setIsSubmitting] = useState(false);
    const queryClient = useQueryClient();

    const { mutate: criarCultura, isLoading: isLoadingCriarCultura } = useMutation({
        mutationKey: "cadastrar-cultura",
        mutationFn: (inputs: { nome: string }) =>
            axiosClient.post("/receituario-agronomico/culturas/adicionar-cultura", inputs),
        onError: (error) => {
            console.error(error);
            enqueueSnackbar("Erro ao cadastrar cultura!", { variant: "error" });
            setIsSubmitting(false);
        },
        onSuccess: () => {
            enqueueSnackbar("Cultura cadastrada com sucesso!", { variant: "success" });
            queryClient.invalidateQueries("pesquisar-culturas");
            setIsSubmitting(false);
            handleClose();
        },
    });

    const { mutate: editarCultura, isLoading: isLoadingEditarCultura} = useMutation({
        mutationKey: "cadastrar-cultura",
        mutationFn: (inputs:ICultura) =>
            axiosClient.put(`/receituario-agronomico/culturas/editar-cultura/${inputs.id}`,{ nome: inputs.nome}),
        onError: (error) => {
            enqueueSnackbar("Erro ao editar cultura!", { variant: "error" });
            setIsSubmitting(false);
        },
        onSuccess: () => {
            enqueueSnackbar("Cultura editada com sucesso!", { variant: "success" });
            queryClient.invalidateQueries("pesquisar-culturas");
            setIsSubmitting(false);
            handleClose();
        },
    });

    const valoresIniciais = useMemo(() => defaultValue?.defaultValue ? defaultValue.defaultValue : null, [defaultValue])
    const methods = useForm<ICultura>({
        defaultValues:{
            id: valoresIniciais?.id,
            nome: valoresIniciais?.nome,
        }
    });
    const { handleSubmit, reset } = methods;

    const onSubmit = (data: ICultura) => {
        const paylod: ICultura = {
            id: data.id ?? null,
            nome: data.nome,
        };
        if (isEdit) {
            editarCultura(paylod);
        } else {
            criarCultura(paylod);
        }
    };

    const handleCloseDialog = () => {
        reset();
        handleClose();
    };

    return (
        <FormProvider {...methods}>
            <Dialog
                open={open}
                onClose={handleCloseDialog}
                maxWidth="xs"
                fullWidth
                PaperComponent={PaperDraggable}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle id="draggable-dialog-title" style={{ cursor: 'move' }}>
                    Cadastrar Cultura
                </DialogTitle>
                <DialogContent>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <TextField
                            label="Nome da cultura"
                            fullWidth
                            autoFocus
                            {...methods.register("nome", { required: "O nome é obrigatório" })}
                            disabled={isSubmitting}
                            margin="normal"
                        />
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="text"
                        onClick={handleCloseDialog}
                        disabled={isSubmitting}
                    >
                        Fechar
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleSubmit(onSubmit)}
                        disabled={isLoadingEditarCultura || isLoadingCriarCultura}
                    >
                        {(isLoadingEditarCultura || isLoadingCriarCultura) && (
                            <CircularProgress size={20} sx={{ marginRight: 1 }} />
                        )}
                        {isEdit ? "Atualizar" : "Cadastrar"}
                    </Button>
                </DialogActions>
            </Dialog>
        </FormProvider>
    );
}

export interface DialogIncluirCulturaProps {
    open: boolean;
    handleClose: () => void;
    defaultValue: TOpenModalCulturas;
}